import { useMemo } from "react"
import { useSelector } from "react-redux"
import fp from "lodash/fp"

import { usePowerlineQuery } from "features/api"
import { selectCurrentOrgId } from "features/store/orgSlice"

interface usePowerlineProps {
  id: number | undefined | null
}

const usePowerline = ({ id }: usePowerlineProps) => {
  const orgId = useSelector(selectCurrentOrgId)

  const {
    currentData: powerline,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = usePowerlineQuery(
    {
      id: Number(id),
      params: { org_id: Number(orgId) },
    },
    {
      skip: !orgId || !id,
    },
  )

  const powerlineById = useMemo(
    () => (powerline ? fp.indexBy("id", [powerline]) : {}),
    [powerline],
  )

  return {
    powerline,
    powerlineById,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

export default usePowerline
